export const AdStatus = Object.freeze({
  PENDING: 'pending',
  EMPTY: 'empty',
  READY: 'ready',
});

export const BannerSizes = Object.freeze({
  '160x600': 'skyscraper',
  '300x250': 'mediumrectangle',
  '300x600': 'mediumrectangle',
  '728x90': 'superbanner',
  '800x250': 'billboard',
});

export const AdOrientation =Object.freeze({
  DESKTOP_RECTANGLE_ANY: 'ver',
  DESKTOP_RECTANGLE_ANY_RL: 'ver',
  DESKTOP_BANNER_SKY_ANY: 'hor',
  DESKTOP_BANNER_ANY: 'hor',
  DESKTOP_SKYSCRAPER_ANY: 'oop',
  DESKTOP_SKYSCRAPER_ANY_RL: 'oop',
  DESKTOP_BANNER_SINGLE_ANY: "hor",
  DESKTOP_LOGOUT_ANY: "hor",
  DESKTOP_WELCOMEAD_ANY: "hor",
});

export const BannerTypes = Object.freeze({
  DESKTOP_BANNER_TOP: 'DESKTOP_BANNER_TOP',
  DESKTOP_BANNER_ANY: 'DESKTOP_BANNER_ANY',
  DESKTOP_BANNER_SINGLE_TOP: 'DESKTOP_BANNER_SINGLE_TOP',
  DESKTOP_BANNER_SINGLE_ANY: 'DESKTOP_BANNER_SINGLE_ANY',
  DESKTOP_BANNER_SINGLE_ANY_RL: 'DESKTOP_BANNER_SINGLE_ANY_RL',
  DESKTOP_BANNER_SKY_ANY: 'DESKTOP_BANNER_SKY_ANY',
  DESKTOP_BANNER_BB_ANY_RL: 'DESKTOP_BANNER_BB_ANY_RL',
  DESKTOP_RECTANGLE_TOP: 'DESKTOP_RECTANGLE_TOP',
  DESKTOP_RECTANGLE_ANY: 'DESKTOP_RECTANGLE_ANY',
  DESKTOP_RECTANGLE_ANY_RL: 'DESKTOP_RECTANGLE_ANY_RL',
  DESKTOP_RECTANGLE_SINGLE_TOP: 'DESKTOP_RECTANGLE_SINGLE_TOP',
  DESKTOP_RECTANGLE_SINGLE_ANY: 'DESKTOP_RECTANGLE_SINGLE_ANY',
  DESKTOP_RECTANGLE_SINGLE_ANY_RL: 'DESKTOP_RECTANGLE_SINGLE_ANY_RL',
  DESKTOP_HPA_SINGLE_TOP: 'DESKTOP_HPA_SINGLE_TOP',
  DESKTOP_HPA_SINGLE_ANY: 'DESKTOP_HPA_SINGLE_ANY',
  DESKTOP_HPA_SINGLE_ANY_RL: 'DESKTOP_HPA_SINGLE_ANY_RL',
  DESKTOP_SKYSCRAPER_TOP: 'DESKTOP_SKYSCRAPER_TOP',
  DESKTOP_SKYSCRAPER_ANY: 'DESKTOP_SKYSCRAPER_ANY',
  DESKTOP_SKYSCRAPER_ANY_RL: 'DESKTOP_SKYSCRAPER_ANY_RL',
  DESKTOP_HEADLINE_ANY: 'DESKTOP_HEADLINE_ANY',
  DESKTOP_LOGOUT_ANY: 'DESKTOP_LOGOUT_ANY',
  DESKTOP_WELCOMEAD_ANY: 'DESKTOP_WELCOMEAD_ANY',
  TABLET_BANNER_TOP: 'TABLET_BANNER_TOP',
  TABLET_BANNER_ANY: 'TABLET_BANNER_ANY',
  TABLET_RECTANGLE_TOP: 'TABLET_RECTANGLE_TOP',
  TABLET_RECTANGLE_ANY: 'TABLET_RECTANGLE_ANY',
  TABLET_RECTANGLE_SINGLE_TOP: 'TABLET_RECTANGLE_SINGLE_TOP',
  TABLET_RECTANGLE_SINGLE_ANY: 'TABLET_RECTANGLE_SINGLE_ANY',
  SMARTPHONE_BANNER_TOP: 'SMARTPHONE_BANNER_TOP',
  SMARTPHONE_BANNER_ANY: 'SMARTPHONE_BANNER_ANY',
  VIDEO_PREROLL: 'VIDEO_PREROLL',
});

export const PageNames = Object.freeze({
  startpage: "startpage",
  activities: "activities",
  communities: "communities",
  companies: "companies",
  contacts: "contacts",
  events: "events",
  groups: "groups",
  jobs: "jobs",
  messages: "messages",
  network: "network",
  premium: "premium",
  profile: "profile",
  projects: "projects",
  search_results: "searchresults",
  logout: "logout",
});
